import styled from 'styled-components';
import OrangArrow from "../../../assests/images/orangeicon.svg";

export const FavoriteNonprofitsBanner = styled.section`
    width: 100%;

    .title-sub-page{
        margin-bottom: 5px;
    }

    .page-content{
        max-width: 987px;
    }
    
    .donate-to-nonprofits-banner{
        @media screen and (max-width: 991px){
            padding: 170px 0 140px;
        }
    }
`;

export const FindGreatCharitiesSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 0px 0px 50px; 
`;

export const FavoriteNonprofitsWrap = styled.div`
    background: #FFFFFF;
    padding: 20px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 15px;
    margin-top: -123px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 575px){
       border-radius: 10px;
    }
`;

export const FavoriteNonprofitsBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 20px;

    @media screen and (max-width: 767px){
        flex-direction: column;
        row-gap: 20px;
    }

`;

export const FavoriteNonprofitsImage = styled.div`
    width: 100%;
    max-width: 320px;
    max-height: 323px;
    border-radius: 10px;
    overflow: hidden;

    @media screen and (max-width: 767px){
        max-width: inherit;
        max-height: 100%;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }
`;

export const FavoriteNonprofitsContent = styled.div`
    width: 100%;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width: 767px){ 
        font-size: 16px;
        line-height: 26px;
    }
`;

export const FavoriteNonprofitsTitle = styled.h2`
    width: 100%;
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 15px;

    @media screen and (max-width: 767px){ 
        font-size: 18px;
        line-height: 28px;
    }
`;

export const FavoriteNonprofitsStrong = styled.strong`
    color: #01606F;
    cursor:pointer;
    font-weight: 700;
`;

export const FavoriteNonprofitsText = styled.p`
    width: 100%;
    margin: 0px;
    padding-bottom: 20px;
    
    @media screen and (max-width: 767px){
        padding-bottom: 15px;
    }

    &:last-child{
        padding-bottom: 0px;
    }
`;

export const StatisticsDonationSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }
`;

export const StatisticsDonationTitle = styled.h2`
    width: 100%;
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 20px;
    
    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const StatisticsDonationWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    column-gap: 24px;

    @media screen and (max-width: 991px){
        flex-direction: column;
        row-gap: 30px;
    }
`;

export const StatisticsDonationBox = styled.div`
    width: calc(50% - 10px);
    background: #FFFFFF;
    padding: 30px;
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 30px;
    border-radius: 20px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 991px){
        width: 100%;
        padding: 20px;
        font-size: 18px;
        line-height: 28px;
       border-radius: 15px;
    }

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 26px;
        padding: 15px;
    }

`;
export const StatisticsDonationStrong = styled.strong`
    color: #01606F;
    cursor:pointer;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;

    @media screen and (max-width: 991px){
        width: 100%;
        padding: 20px;
        font-size: 18px;
        line-height: 28px;
    }

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 26px;
    }
`;

export const StatisticsDonationText = styled.p`
    margin: 0;
`;

export const StatisticsDonationUnorderedList = styled.ul`
    padding: 0;
    list-style: none;
    margin-top: 14px;
`;

export const StatisticsDonationListView = styled.li`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 24px;
    padding-left: 28px;
    position: relative;

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 26px;
    }

    &::before{
        content: '';
        position: absolute;
        background-image:url(${OrangArrow});
        width: 28px;
        height: 18px;
        background-repeat: no-repeat;
        left: 0;
        top: 2px;
    }
`;

export const DonationListViewStrong = styled.strong`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 24px;

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 26px;
    }
`;

export const HowToUseSection = styled.section`
    width: 100%;    
    background: #F1FEFF;
    padding-bottom: 50px;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }    
`;
export const HowToUseWrap = styled.div`
    background: #FFFFFF;
    border-radius: 20px;
    padding: 30px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 24px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 991px){
        padding: 20px;
    }

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 26px;
        padding: 15px;
        padding: 15px;
        border-radius: 15px;
    }
`;

export const HowToUseTitle = styled.div`
    width: 100%;
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 60px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 50px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
         margin-bottom: 40px;
    }
`;

export const HowToUseBoxWrap = styled.ul`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    gap: 50px 20px;
    padding: 0;
    list-style: none;
    position: relative;
    counter-reset: li;
    margin-bottom: 0px;
`;

export const HowToUseBox = styled.li`
    width: calc(50% - 10px);
    padding: 45px 20px 20px 30px;
    background: #EFEFEF;
    border-radius: 15px;
    position: relative;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 30px;
    position: relative;

    @media screen and (max-width: 991px){
        width: 100%;
    }

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 26px;
    }

    @media screen and (max-width: 575px){
       border-radius: 10px;
       padding: 40px 20px 20px 20px;
    }

    &:last-child{
        width: 100%;
        margin-bottom: 0px;
    }

    &::before{
        content: counter(li);
        counter-increment: li;
        position: absolute;
        top: -30px;
        left: 30px;
        width: 60px;
        height: 60px;
        background: #33A7AE;
        color: #fff;
        font-family: 'Jost', sans-serif;
        font-size: 30px;
        line-height: 42px;
        font-weight: 700;
        justify-content: center;
        align-items: center;
        display: inline-flex;
        border-radius: 13px;

        @media screen and (max-width: 575px){
            width: 50px;
            height: 50px;
            font-size: 24px;
            line-height: 46px;
            border-radius: 10px;
            top: -23px;
            left: 20px;
        }
    }
`;

export const HowToUseBoxTitle = styled.h3`
    color: #01606F;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 15px;

    @media screen and (max-width: 991px){
        margin-bottom: 10px;
    }
`;

export const HowToUseBoxText = styled.p`
   margin: 0;
`;

export const HowToUseBoxStrong = styled.strong`
    font-weight: 700;
`;